import { render, staticRenderFns } from "./StudentLibrary.vue?vue&type=template&id=2480e700&"
import script from "./StudentLibrary.vue?vue&type=script&lang=js&"
export * from "./StudentLibrary.vue?vue&type=script&lang=js&"
import style0 from "./StudentLibrary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports